import controller from './text-field-controller';
import template from './text-field.html';

const TextFieldComponent = {
    bindings: {
        hideLabel: '<',
        isRequired: '<',
        label: '<',
        labelClass: '<',
        fieldName: '<',
        inputClass: '<',
        parentForm: '<',
        pattern: '<',
        placeholder: '<',
        type: '<',
        value: '=',
        onValueChange: '&'
    },
    controller,
    template
};

export default TextFieldComponent;



// WEBPACK FOOTER //
// ./app/common/form-fields/text-field/text-field-component.js